import { DeviceAssociationGetAllResponse, DeviceAssociationTable } from '@quromedical/models';
import { PaginatedTable } from 'core/table';
import { FetcherOptions } from 'hooks/usePaginatedData';
import { DeviceAssociationApi } from 'integration/aggregate';
import React, { useCallback } from 'react';

import { deviceUseStatementColumns, getDataFromResponse } from './columns';

const deviceAssociationApi = new DeviceAssociationApi();

interface DeviceUseStatementListProps {
  deviceId: string;
}

export const DeviceUseStatementList: React.FC<DeviceUseStatementListProps> = ({ deviceId }) => {
  const deviceUseStatementFetcher = useCallback(
    (options?: FetcherOptions) =>
      deviceAssociationApi.getDeviceAssociations({
        device: deviceId,
        pageToken: options?.nextToken,
        ...options,
      }),
    [deviceId]
  );

  return (
    <PaginatedTable<Partial<DeviceAssociationTable>, DeviceAssociationGetAllResponse>
      cacheKey={`DeviceUseStatement${deviceId}`}
      fetcher={deviceUseStatementFetcher}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      columns={deviceUseStatementColumns}
      showHeader={true}
      getDataFromResponse={getDataFromResponse}
      canChangeCount
    />
  );
};
